import { Schema } from "effect"

/**
 * Supported XSLT engines
 */
export const Engine = Schema.Literal(
  "Saxon6",
  "Saxon9",
  "Saxon10",
  "Saxon11",
  "Saxon12",
  "Xalan2",
  "libxslt",
  "Saxon12CS",
  "Xee"
)
export type Engine = typeof Engine.Type

/**
 * Human-readable engine names
 */
export const EngineNames: Record<Engine, string> = {
  Saxon6: "Saxon 6.5.5",
  Saxon9: "Saxon 9.9 HE",
  Saxon10: "Saxon 10.9 HE",
  Saxon11: "Saxon 11.7 HE",
  Saxon12: "Saxon 12.9 HE",
  Xalan2: "Xalan 2.7.3",
  libxslt: "libxslt",
  Saxon12CS: "Saxon 12.9 CS (.NET)",
  Xee: "Xee (Rust XSLT 3.0)",
}

/**
 * Default engine for new fiddles
 */
export const DEFAULT_ENGINE: Engine = "Saxon12"
